import { Amplify } from 'aws-amplify';
import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito';

/**
 * Configure AWS Amplify with Cognito settings
 * This file should be imported in the main entry point of the application
 */
const configureAmplify = () => {
  // Get Cognito configuration from environment variables
  const userPoolId = import.meta.env.VITE_COGNITO_USER_POOL_ID;
  const clientId = import.meta.env.VITE_COGNITO_CLIENT_ID;
  const region = import.meta.env.VITE_AWS_REGION || 'ap-southeast-2';
  const endpoint = import.meta.env.VITE_AWS_ENDPOINT_URL;
  
  // Brevo is used for email functionality instead of Pinpoint

  // Check if Cognito is configured
  if (!userPoolId || !clientId) {
    console.warn('Cognito is not configured. Authentication will not work.');
    return;
  }

  // Configure Amplify
  const config: any = {
    Auth: {
      Cognito: {
        userPoolId,
        userPoolClientId: clientId,
        loginWith: {
          phone: true,
          email: false,
          username: false
        }
      }
    }
  };

  // Add API configuration if endpoint is available
  // Use the current origin with the path '/graphql' to go through the Vite proxy
  const apiEndpoint = import.meta.env.VITE_API_ENDPOINT || (typeof window !== 'undefined' ? `${window.location.origin}/graphql` : 'http://localhost:5173/graphql');
  if (apiEndpoint) {
    config.API = {
      GraphQL: {
        endpoint: apiEndpoint,
        region: region,
        defaultAuthMode: 'userPool'
      }
    };
  }

  // If using LocalStack, we need to configure the endpoints
  if (endpoint) {
    // For LocalStack, we need to set up custom endpoints
    // This is done by modifying the Auth configuration
    // @ts-ignore - Adding custom endpoint property
    config.Auth.Cognito.endpoint = endpoint;
  }

  // Configure Amplify
  Amplify.configure(config);

  // Configure token provider
  cognitoUserPoolsTokenProvider.setKeyValueStorage({
    getItem: (key: string) => {
      const value = localStorage.getItem(key);
      return Promise.resolve(value);
    },
    setItem: (key: string, value: string) => {
      localStorage.setItem(key, value);
      return Promise.resolve();
    },
    removeItem: (key: string) => {
      localStorage.removeItem(key);
      return Promise.resolve();
    },
    clear: () => {
      localStorage.clear();
      return Promise.resolve();
    }
  });

  // Log configuration details
  console.log('AWS Amplify configured with:');
  console.log('- User Pool ID:', userPoolId);
  console.log('- Client ID:', clientId);
  console.log('- API Endpoint:', apiEndpoint);
  if (endpoint) {
    console.log('- Using LocalStack endpoint:', endpoint);
  }
  console.log('AWS Amplify configured successfully');
};

export default configureAmplify;
